module.exports = __webpack_public_path__ + "static/media/denny2024_notalk.afc0fc2e.png";